import { AppDate } from '../envTypes';

import { Profile } from './profile';

export enum FollowFrom {
  INVITATION = 'invitation',
  COUPON = 'coupon',
  SELF = 'self',
}

export interface PromotionalOfferDetails {
  receivePromotionalOffers: boolean;
  receivePromotionalOffersToggledAt: AppDate;
}

export interface SharePhoneNumberConsent {
  sharePhoneNumber: boolean;
  sharePhoneNumberTimestamp: AppDate;
}

export interface ProfileFollower extends Profile {
  timestamp: AppDate;
  followFrom?: FollowFrom;
  promotionalOfferDetails?: PromotionalOfferDetails;
  // for legacy records, default to true
  sharePhoneNumberConsent?: SharePhoneNumberConsent;
}

export interface Follower {
  user: Profile;
  followAt: AppDate;
}
